export function getTreatmentFeeDiscounts(discounts) {
  return discounts.filter(discount => !discount.is_applied_to_payor)
}
